import React from "react";

// material-ui components
import withStyles from "material-ui/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";

import SimpleInput from "components/SimpleInput/SimpleInput.jsx";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  inputAdornment: {
    top: "3px",
    position: "relative",
  }
};

const aboutFields = [
      {name:"nickname",label:"Nickname",size:9},
];


class Step1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldState: {},
    };
    this.change = this.change.bind(this);

  }
  // function that returns true if value is email, false otherwise
  verifyEmail(value) {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }
  // function that verifies if a string has a given length or not
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }
  change(event, stateName, type, stateNameEqualTo) {
    let value = event.target?event.target.value:null;
    switch (type) {
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ fieldState: {[stateName]: "success" }});
        } else {
          this.setState({ fieldState: {[stateName]: "error" }});
        }
        break;
      case "length":
        if (this.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({ fieldState: {[stateName]: "success" }});
        } else {
          this.setState({ fieldState: {[stateName]: "error" }});
        }
        break;
      default:
        break;
    }
    this.props.change({ [stateName]: value });
    this.setState({ [stateName]: value });
  }
  isValidated() {
    return true;
  }
  render() {
    const { classes } = this.props;
    return (
      <GridContainer justify="center">
        <ItemGrid xs={12} sm={12}>
          <h4 className={classes.infoText}>
            Let's start with the basic information (with validation)
          </h4>
        </ItemGrid>

        {aboutFields.map((prop,key)=>{
        return (
          <SimpleInput 
            success={this.state.fieldState[prop.name] === "success"}
            error={this.state.fieldState[prop.name] === "error"}
            key={key} 
            type={prop.type}  
            name={prop.name} 
            label={prop.label} 
            classes={classes} 
            size={prop.size} 
            handler={this.change} 
          />
        )})}

      </GridContainer>
    );
  }
}


export default withStyles(style)(Step1);



// WEBPACK FOOTER //
// ./src/views/Receiver/AddLocationWizardSteps/Step1.jsx